module.exports = __webpack_public_path__ + "static/media/exit.3954de58.svg";